import React from 'react'
import firebase, { FirebaseContext } from "./src/services/firebase"
import 'react-phone-number-input/style.css'

export const wrapRootElement = ({ element }) => (
  <FirebaseContext.Provider value={firebase}>
    {element}
  </FirebaseContext.Provider>
)